import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { GlobalErrorHandlerService } from './global-error-handler.service';

import { Clinic } from '../clinic/clinic';

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};

@Injectable({
  providedIn: 'root'
})
export class UserPreferenceService {
  private userPreferenceUrl = '/api/user_preferences';

  constructor(
    private http: HttpClient,
    private errorHandler: GlobalErrorHandlerService
  ) { }

  updateUserPreference(id: number, preferenceName: string, preferenceValue: any): Observable<any> {
    let preference = { 'id': id };
    preference[preferenceName] = preferenceValue;

    return this.http
      .put(this.userPreferenceUrl, preference, httpOptions)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  updateSelectedClinic(userId: number, clinicId: number): Observable<Clinic> {
    return this.http
      .put(`${this.userPreferenceUrl}/clinic`, { 'user_id': userId, 'clinic_id': clinicId }, httpOptions)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  getSelectedClinic(userId: number): Observable<Clinic> {
    return this.http
      .get<Clinic>(`${this.userPreferenceUrl}/clinic/${userId}`)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }
}
